import React from "react";
import { TicketData, VenueData, TicketGroupData } from "../types";

interface TicketListProps {
  tickets: TicketData[];
  hasMultipleVenues?: boolean;
  venues?: VenueData[];
  hasMultipleTicketGroups?: boolean;
  ticketGroups?: TicketGroupData[];
  onTicketToggle: (ticketId: string, isActive: boolean) => void;
  onEditTicket: (ticket: TicketData) => void;
  onDeleteTicket: (ticketId: string) => void;
}

const TicketList: React.FC<TicketListProps> = ({
  tickets,
  onEditTicket,
  onDeleteTicket,
}) => {
  return (
    <div className="ticket-list-wrapper mt-3">
      {tickets.length === 0 ? (
        <p className="text-muted">No tickets created yet.</p>
      ) : (
        <ul className="list-group">
          {tickets.map((t) => (
            <li key={t.id} className="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <strong>{t.name}</strong> - Price: {t.price === 0 ? "Free" : `$${t.price}`} ({t.type})
                {t.description && <p className="mb-0 text-muted fs-12">{t.description}</p>}
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() => onEditTicket(t)}
                >
                  Edit
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onDeleteTicket(t.id)}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TicketList;
